<div class="container">
  <mat-toolbar class="{{env}}-toolbar">
    <div class="logo-container tw-flex tw-justify-around tw-content-center tw-items-center tw-flex-row">
      <img src="../../../../assets/img/aiwaylogo_40.png" class="logo">
      <div class="{{env}}-environment-name">
        {{(env == 'local') ? 'Local' : (env == 'staging' ? 'Staging' : '')}}
      </div>
    </div>
  </mat-toolbar>

  <div class="tw-mt-[5%] tw-flex tw-justify-center tw-content-center tw-items-center tw-flex-row">
    <form [formGroup]="loginForm" class="login-form">
      <label>Username</label>
      <mat-form-field appearance="outline">
        <input autocomplete="off" formControlName="username" matInput type="text" />
      </mat-form-field>
      <br>
      <label>Password</label>
      <mat-form-field appearance="outline">
        <input autocomplete="off" formControlName="password" matInput type="password" />
      </mat-form-field>
      <mat-error class="login-error">{{ error$ | async }}</mat-error>
      <div style="width: 100%" class="tw-flex tw-justify-between tw-content-center tw-items-center tw-flex-row">
        <button color="primary" mat-flat-button (click)="login()" [disabled]="loading && (error$ | async) === ''">
          Login
        </button>
      </div>
    </form>
  </div>

</div>